/* eslint-disable perfectionist/sort-objects */
import { differenceInYears } from 'date-fns';
export const genderTypeEnum = {
    FEMALE: 'Mme.',
    MALE: 'Mr.',
};
export const travelClassTypeEnum = {
    BUSINESS: 'Business',
    ECONOMY: '\u00c9conomique',
    PREMIUM: 'Premium',
};
export const flightTypeEnum = {
    ROUND_TRIP: 'Aller-retour',
    ONE_WAY: 'Aller simple',
    MULTI_DESTINATION: 'Multi-destination',
};
export const pensionTypeEnum = {
    ALL_INCLUSIVE: 'All inclusive',
    BREAKFAST: 'Petit d\u00e9jeuner',
    FULL_BOARD: 'Pension compl\u00e8te',
    HALF_BOARD: 'Demi-pension',
    ROOM_ONLY: 'Chambre seule',
};
export const tourismTypeEnum = {
    CRUISE: 'Croisi\u00e8re',
    STAY: 'S\u00e9jour, package',
    TOUR: 'Circuit',
};
export const HOTEL_STARS_OPTIONS = [
    { label: 'Aucune', value: 'none' },
    { label: '2 \u00e9toiles', value: '2' },
    { label: '3 \u00e9toiles', value: '3' },
    { label: '4 \u00e9toiles', value: '4' },
    { label: '5 \u00e9toiles', value: '5' },
];
// ---- Flight Search Enum (kebab-case keys for URL-friendly search params) ----
export const flightSearchEnum = {
    'round-trip': 'Aller-retour',
    'one-way': 'Aller simple',
    'multi-destination': 'Multi-destinations',
};
export const flightPassengerCategoriesLabels = {
    adult: 'Adulte',
    baby: 'Bébé',
    infant: 'Enfant',
    senior: 'Senior',
};
export function calculateAge(birthDate) {
    const parsedBirthDate = birthDate instanceof Date ? birthDate : new Date(birthDate);
    if (Number.isNaN(parsedBirthDate.getTime())) {
        return 0;
    }
    return differenceInYears(new Date(), parsedBirthDate);
}
export function getGenderLabel(gender) {
    if (gender === 'MALE')
        return 'Homme';
    return 'Femme';
}
export function getPassengerTypeLabel(age) {
    if (age <= 2)
        return 'Bébé';
    if (age <= 12)
        return 'Enfant';
    return 'Adulte';
}
